// workflowLayoutService.js
import { doc, getDoc, setDoc, Timestamp } from 'firebase/firestore';
import { db } from './firebase';

// Canvas node positions live in a SEPARATE doc from the workflow's own statuses/branches
// (workflowLayouts/{workflowId}, keyed 1:1 with workflows/{workflowId}) rather than inline on the
// workflow doc — see the workflow engine plan's Phase 3 note: List-view edits and Canvas-view
// drags would otherwise both setDoc the same whole `statuses` array, and workOrderStatusesContext
// already has a real precedent for that kind of race silently stomping a write. Canvas view never
// touches `statuses`, List view never touches this collection — the race is impossible by
// construction, not just avoided by convention.

export const getWorkflowLayout = async (workflowId) => {
  const snap = await getDoc(doc(db, 'workflowLayouts', workflowId));
  return snap.exists() ? snap.data() : null;
};

// edgeLanes — { [branchId]: laneX } — an admin's manual override for where a long/routed branch's
// side lane sits, set by dragging its label (see WorkflowCanvas.js's BranchEdge). Lives in this
// same layout doc rather than on the branch/transition itself in `statuses[]`, for the same reason
// node positions do: it's a purely visual/canvas concern, meaningless to List view or any other
// consumer of the workflow's actual status/branch data.
export const saveWorkflowLayout = async (workflowId, companyId, positions, edgeLanes) => {
  await setDoc(doc(db, 'workflowLayouts', workflowId), {
    companyId, positions, edgeLanes: edgeLanes || {}, updatedAt: Timestamp.now()
  }, { merge: true });
};
